function findLeaveBalance(leaveTypeId, leaveBalances) {
  if (leaveTypeId == null || !Array.isArray(leaveBalances)) return null;

  return (
    leaveBalances.find(
      (entry) => String(entry.leaveTypeId) === String(leaveTypeId)
    ) ?? null
  );
}

export function getAvailableLeaveBalanceForType(leaveType, leaveBalances) {
  if (!leaveType) return null;

  const entry = findLeaveBalance(leaveType.typeId, leaveBalances);
  return entry?.available ?? null;
}

export function getLeaveBalanceSummary(leaveTypeId, leaveBalances) {
  const entry = findLeaveBalance(leaveTypeId, leaveBalances);
  if (!entry) return null;

  return {
    available: entry.available ?? null,
    total: entry.total ?? null,
    used: entry.leavesApproved ?? entry.used ?? null,
    leavesApproved: entry.leavesApproved ?? entry.used ?? null,
  };
}

export function formatLeaveBalanceLabel(summary) {
  if (!summary) return "—";
  if (summary.available != null && summary.total != null) {
    return `${Number(summary.available).toFixed(1)} / ${Number(summary.total).toFixed(1)} Days`;
  }
  if (summary.available != null) {
    const label = summary.available === 1 ? "Day" : "Days";
    return `${Number(summary.available).toFixed(1)} ${label}`;
  }
  return "—";
}

export function calculatePendingLeaveBalance(empId, leaveTypeId, leaveBalancesByEmp) {
  const balances =
    leaveBalancesByEmp?.[empId] ??
    leaveBalancesByEmp?.[String(empId)] ??
    [];

  return getLeaveBalanceSummary(leaveTypeId, balances);
}
